import { useSelector } from "react-redux"
import { selectConfig } from "~/slices/configSlice"
import { Values } from "~/model/Config"

export function useConfig() {
  const config = useSelector(selectConfig)

  function getSelectedValue(name: string) {
    return [
      {
        label: "すべて",
        value: null,
      },
    ].concat(
      config.masters[name].map((item) => ({
        label: item.label,
        value: String(item.value),
      })) as []
    )
  }

  function getConfigToLabel(name: string, value: string | number) {
    const data = Object.fromEntries((config.masters[name] || []).map((item: Values) => [item.value, item.label]))
    return data[value]
  }

  function getConfigTo(name: string, key: string, value: string) {
    return Object.fromEntries((config.masters[name] || []).map((item: any) => [item[key], item[value]]))
  }

  function getConfigKeyValue<T>(name: string) {
    const data = Object.fromEntries(
      (config.masters[name] || []).map((item: Values) => {
        return [item.value, item.values || item.label]
      })
    )
    return data
  }

  function getConfigKeyData<T>(name: string) {
    const data = Object.fromEntries(
      (config.masters[name] || []).map((item: Values) => {
        return [item.value, item]
      })
    )
    return data
  }

  function getConfig<T>(key: string): T {
    return config.masters[key] as never
  }

  return {
    getSelectedValue,
    getConfigToLabel,
    getConfigTo,
    getConfig,
    getConfigKeyValue,
    getConfigKeyData,
  }
}
